import { useHistory } from 'react-router';
import * as qs from 'query-string';

import usePathName from 'hooks/usePathName';

interface IrouteParam {
  path?: string;
  removeSearch?: Array<string>;
  // eslint-disable-next-line @typescript-eslint/ban-types
  search?: Object;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function useRouterHelper<T>() {
  const history = useHistory();
  const path = usePathName();
  const query = qs.parse(window.location.search);

  function routePush(params: IrouteParam) {
    if (params.removeSearch) {
      params.removeSearch.forEach(key => {
        delete query[key];
      });
    }
    const queryMerged = {
      ...query,
      ...params.search,
    };

    history.push({
      pathname: params.path ?? path,
      search: Object.keys(queryMerged)
        .map(key => {
          return `${key}=${queryMerged[key]}`;
        })
        .join('&'),
    });
  }

  return {
    routePush,
    query,
  };
}
